import PropTypes from 'prop-types';
import React from 'react';
import BsFacebook from '../icons/BsFacebook';
import BsEnvelope from '../icons/BsEnvelope';
import BsPrinter from '../icons/BsPrinter';

const ShareIcon = ({children, link}) => {
    let tooltipLabel = '';
    
    if (React.isValidElement(children)) {
        if (children.type === BsFacebook) {
            tooltipLabel = 'Facebook';
        } else if (children.type === BsEnvelope) {
            tooltipLabel = 'Email';
        } else if (children.type === BsPrinter) {
            tooltipLabel = 'Print';
        }
    }
    
    return (
        <a
            href={link}
            className={'share-icon'}
            rel={'noreferrer'}
            target={'_blank'}
        >
            {children}
            {tooltipLabel && <span 
                className={'share-icon-tooltip'}
            >{tooltipLabel}</span>}
        </a>
    );
};

ShareIcon.propTypes = { 
    children: PropTypes.node,
    link: PropTypes.string
};

export default ShareIcon;